// extracted by mini-css-extract-plugin
export default {"textareaWrapper":"nUIFF93I","textarea":"tW6rETvR","textareaLabel":"jy5LN_XF"};